import { useState, useEffect, useCallback } from 'react'
import {
  AcknowledgementRecord,
  getAcknowledgementHistory
} from '../services/acknowledgementService'

interface UseAcknowledgementHistoryResult {
  records: AcknowledgementRecord[]
  loading: boolean
  error: string | null
  refetch: () => void
}

export function useAcknowledgementHistory(
  userId: string | undefined
): UseAcknowledgementHistoryResult {
  const [records, setRecords] = useState<AcknowledgementRecord[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetch = useCallback(async () => {
    if (!userId) return
    setLoading(true)
    setError(null)
    try {
      const result = await getAcknowledgementHistory(userId)
      setRecords(result)
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Failed to load acknowledgements'
      )
    } finally {
      setLoading(false)
    }
  }, [userId])

  useEffect(() => {
    fetch()
  }, [fetch])

  return { records, loading, error, refetch: fetch }
}
